import { render, staticRenderFns } from "./SalesReportDownloadRestrictionDialog.vue?vue&type=template&id=f378b1e0&lang=pug&"
import script from "./SalesReportDownloadRestrictionDialog.vue?vue&type=script&lang=js&"
export * from "./SalesReportDownloadRestrictionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports